<script>
  /** @type {string} */
  export let classes = ""
  export let open = false

  import { createEventDispatcher } from "svelte"

  /** @type {HTMLDialogElement} */
  let dialog
  const dialogDescriptionId = `dialog_description_${(Math.random() + 1).toString(36).slice(2)}`
  const dialogTitleId = `dialog_title_${(Math.random() + 1).toString(36).slice(2)}`
  const dispatch = createEventDispatcher()

  $: {
    if (dialog) {
      if (open) {
        dialog.showModal()
      } else {
        dialog.close()
      }
    }
  }

  function showModal() {
    open = true
  }

  function closeModal() {
    open = false
  }

  function handleClose() {
    open = false
    dispatch("escape")
  }
</script>

<slot name="trigger" {showModal} {closeModal} />
<dialog
  bind:this={dialog}
  on:close={handleClose}
  aria-labelledby={dialogTitleId}
  aria-describedby={dialogDescriptionId}
  class={`outline-none -translate-y-2/4 top-[50vh] sm:top-0 sm:translate-y-0 border-transparent p-0 flex items-center justify-center bg-transparent ${classes}`}
  {...$$restProps}
>
  {#if open}
    <div class="relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:max-w-lg">
      <slot {showModal} {closeModal} {dialogDescriptionId} {dialogTitleId} />
    </div>
  {/if}
</dialog>

<style>
  dialog::backdrop {
    @apply bg-gray-900/30;
  }

  dialog[open] {
    @apply w-full h-full;
  }
</style>
